import api from "../lib/api";
import publicApi from "../lib/publicApi";
import { configuredBackendBase } from "../lib/backendUrl";
import { isBackgroundSignal } from "../lib/requestActivity";
import { publishBrandingChange, tenantBrandingScope } from "../lib/brandingChanges";

export async function updateTenantCompanySettings(body, merchantId) {
  const response = await api.put("/settings", body);
  publishBrandingChange(tenantBrandingScope(merchantId));
  return response;
}

export async function getTenantContext(preview, signal) {
  const response = await api.get("/tenant/context", { signal, params: preview ? { merchant: preview } : undefined,
    globalLoader: false, ...(isBackgroundSignal(signal) ? { timeout: 10000 } : {}) });
  return response.data || {};
}

/** Resolve the browser hostname without attaching a saved staff session or URL hint. */
export async function getDomainEntryContext(signal) {
  const hostname = window.location.hostname.toLowerCase();
  const local = ["localhost", "127.0.0.1", "0.0.0.0", "::1", "[::1]"].includes(hostname)
    || hostname.endsWith(".localhost");
  const baseURL = local ? `${configuredBackendBase()}/api` : "/api";
  const response = await publicApi.get("/tenant/context", { baseURL, signal, timeout: 10000, skipMerchantCode: true });
  return response.data || {};
}
